
enum Colors {
    Primary = "#1aa5cf",
    Secondary = "#1aa5cf",
    Grey = "#8f8f8f"
}

export default Colors;